import { IBase, ICoordinate, IFavoriteResponse, IReservation, ISearchedType, ISearchStop, IServiceInfo, IStop } from '../../../models'

export enum BusStopsStepTypeKeys {
  RESET_NEW_RESERVATION_FIELDS = 'RESET_NEW_RESERVATION_FIELDS',
  SET_NEW_RESERVATION_FIELDS = 'SET_NEW_RESERVATION_FIELDS',
  SET_FAVORITE_NEW_RESERVATION_FIELDS = 'SET_FAVORITE_NEW_RESERVATION_FIELDS',
  FETCH_SERVICES = 'FETCH_SERVICES',
  FETCHING_SERVICES = 'FETCHING_SERVICES',
  FETCH_SERVICES_SUCCESSFUL = 'FETCH_SERVICES_SUCCESSFUL',
  SET_IS_SEARCHING = 'SET_IS_SEARCHING',
  SEARCH_STOPS = 'SEARCH_STOPS',
  SET_SEARCH_STOPS = 'SET_SEARCH_STOPS',
  SEARCH_STOP_COORDINATES = 'SEARCH_STOP_COORDINATES',
  SET_SEARCHED_RESULT = 'SET_SEARCHED_RESULT',
  SET_SELECT_MARKER_FLAG = 'SET_SELECT_MARKER_FLAG',
  SET_BUS_STOP = 'SET_BUS_STOP',
  FETCH_DESTINATION_BUS_STOPS = 'FETCH_DESTINATION_BUS_STOPS',
  FETCHING_DESTINATION_BUS_STOPS = 'FETCHING_DESTINATION_BUS_STOPS',
  FETCH_DESTINATION_BUS_STOPS_SUCCESSFUL = 'FETCH_DESTINATION_BUS_STOPS_SUCCESSFUL',
  SET_MAP_CHANGED_CENTER = 'SET_MAP_CHANGED_CENTER',
  RESET_MAP_CHANGED_CENTER = 'RESET_MAP_CHANGED_CENTER',
  SET_SERVICE_SELECTED = 'SET_SERVICE_SELECTED',
  SET_USER_LOCATION = 'SET_USER_LOCATION',
  SET_ROUND_TRIP = 'SET_ROUND_TRIP',
  SET_SHOW_TRIP_TYPE_OPTIONS = 'SET_SHOW_TRIP_TYPE_OPTIONS',
  SHOW_SINGLE_STOP_MODAL = 'SHOW_SINGLE_STOP_MODAL',
  SET_SINGLE_BUS_STOP_DIRECTION = 'SET_SINGLE_BUS_STOP_DIRECTION',
  RESET_SINGLE_BUS_STOP = 'RESET_SINGLE_BUS_STOP',
}

export interface IResetNewReservationFieldsAction {
  type: typeof BusStopsStepTypeKeys.RESET_NEW_RESERVATION_FIELDS
}

export interface ISetNewReservationFieldsAction {
  type: typeof BusStopsStepTypeKeys.SET_NEW_RESERVATION_FIELDS
  payload: IReservation
}

export interface ISetFavoriteNewReservationFieldsAction {
  type: typeof BusStopsStepTypeKeys.SET_FAVORITE_NEW_RESERVATION_FIELDS
  payload: IFavoriteResponse
}

export interface IFetchServicesAction {
  type: typeof BusStopsStepTypeKeys.FETCH_SERVICES
}

export interface ISetIsFetchingServicesAction {
  type: typeof BusStopsStepTypeKeys.FETCHING_SERVICES
}

export interface IFetchServicesSuccessfulAction {
  type: typeof BusStopsStepTypeKeys.FETCH_SERVICES_SUCCESSFUL
  payload: IServiceInfo[]
}

export interface ISetIsSeachingAction {
  type: typeof BusStopsStepTypeKeys.SET_IS_SEARCHING
  payload: boolean
}

export interface ISearchStopsAction {
  type: typeof BusStopsStepTypeKeys.SEARCH_STOPS
  payload: string
}

export interface ISetSearchStopsAction {
  type: typeof BusStopsStepTypeKeys.SET_SEARCH_STOPS
  payload: IBase[]
}

export interface ISearchStopCoordinatesAction {
  type: typeof BusStopsStepTypeKeys.SEARCH_STOP_COORDINATES
  payload: ISearchStop
}

export interface ISetSearchedStopResultAction {
  type: typeof BusStopsStepTypeKeys.SET_SEARCHED_RESULT
  payload: { name: string }
}

export interface ISetSelectMarkerFlagAction {
  type: typeof BusStopsStepTypeKeys.SET_SELECT_MARKER_FLAG
  payload: boolean
}

export interface ISetBusStopAction {
  type: typeof BusStopsStepTypeKeys.SET_BUS_STOP
  payload: { stop: IStop }
}

export interface IFetchDestinationBusStopsAction {
  type: typeof BusStopsStepTypeKeys.FETCH_DESTINATION_BUS_STOPS
  payload: { idTown: number; stop: IStop }
}

export interface ISetIsFetchingDestinationBusStopsAction {
  type: typeof BusStopsStepTypeKeys.FETCHING_DESTINATION_BUS_STOPS
}

export interface IFetchDestinationBusStopsSuccesfulAction {
  type: typeof BusStopsStepTypeKeys.FETCH_DESTINATION_BUS_STOPS_SUCCESSFUL
  payload: IStop[]
}

export interface ISetMapChangedCenterAction {
  type: typeof BusStopsStepTypeKeys.SET_MAP_CHANGED_CENTER
  payload: ICoordinate
}

export interface IResetMapChangedCenterAction {
  type: typeof BusStopsStepTypeKeys.RESET_MAP_CHANGED_CENTER
}

export interface ISetServiceSelectedAction {
  type: typeof BusStopsStepTypeKeys.SET_SERVICE_SELECTED,
  payload: any
}

export interface ISetUserLocationAction {
  type: typeof BusStopsStepTypeKeys.SET_USER_LOCATION,
  payload: ICoordinate | undefined
}

export interface ISetRoundTripAction {
  type: typeof BusStopsStepTypeKeys.SET_ROUND_TRIP,
  payload: boolean
}

export interface ISetShowTripTypeOptionsActions {
  type: typeof BusStopsStepTypeKeys.SET_SHOW_TRIP_TYPE_OPTIONS,
  payload: boolean
}

export interface ISetShowSingleStopModalAction {
  type: typeof BusStopsStepTypeKeys.SHOW_SINGLE_STOP_MODAL,
  payload: {isSingleStopModalOpen: boolean, stop?: IStop}
}

export interface ISetSingleBusStopDirectionAction {
  type: typeof BusStopsStepTypeKeys.SET_SINGLE_BUS_STOP_DIRECTION
  payload: boolean
}

export interface IResetSingleBusStopAction {
  type: typeof BusStopsStepTypeKeys.RESET_SINGLE_BUS_STOP
}

export type BusStopsStepActionTypes =
 | IResetNewReservationFieldsAction
 | ISetNewReservationFieldsAction
 | ISetFavoriteNewReservationFieldsAction
 | IFetchServicesAction
 | ISetIsFetchingServicesAction
 | IFetchServicesSuccessfulAction
 | ISetIsSeachingAction
 | ISearchStopsAction
 | ISetSearchStopsAction
 | ISearchStopCoordinatesAction
 | ISetSearchedStopResultAction
 | ISetSelectMarkerFlagAction
 | ISetBusStopAction
 | IFetchDestinationBusStopsAction
 | ISetIsFetchingDestinationBusStopsAction
 | IFetchDestinationBusStopsSuccesfulAction
 | ISetMapChangedCenterAction
 | IResetMapChangedCenterAction
 | ISetServiceSelectedAction
 | ISetUserLocationAction
 | ISetRoundTripAction
 | ISetShowTripTypeOptionsActions
 | ISetShowSingleStopModalAction
 | ISetSingleBusStopAction
 | IResetSingleBusStopAction
